import { render } from "./CarouselDesk.vue?vue&type=template&id=41d57c00&scoped=true"
const script = {}

import "./CarouselDesk.vue?vue&type=style&index=0&id=41d57c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d57c00"]])

export default __exports__